import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { authorizationService } from "@/services/continente-credentials/common/AuthorizationService";

import LoadingLogo from "@/components/loading-logo/loading-logo";
import { useAuthorizeSRTQueryParams } from "../../hooks/continente-credentials/useAuthorizeSRTQueryParams";
import { AuthorizeSRTQueryParams } from "@/models/continente-credentials/common/AuthorizeSRTQueryParams";

import SendAuthorizationCodeMessage from "../../utils/send-message/send-message";

export default function AuthorizeSRT() {
  const history = useHistory();
  const authorizeQueryParams: AuthorizeSRTQueryParams =
    useAuthorizeSRTQueryParams();

  useEffect(() => {
    const initialize = async () => {
      const resp = await authorizationService.authorizeSRT({
        clientId: authorizeQueryParams.clientId || "",
        sessionId: authorizeQueryParams.sessionId || "",
        srToken: authorizeQueryParams.srToken || "",
      });

      switch (resp.kind) {
        case "success": {
          if (resp.value.nextStep.includes("auth/success")) {
            const resp = await authorizationService.authorize({
              clientId: authorizeQueryParams.clientId || "",
            });

            switch (resp.kind) {
              case "success":
                SendAuthorizationCodeMessage({
                  type: "success",
                  authorization_code: resp.value.authorizationCode,
                  code_verifier: resp.value.codeVerifier,
                });
                break;
              case "redirect":
                window.location.href = resp.url;
                break;
            }
            break;
          } else {
            history.push(resp.value.nextStep.substring(4), resp.value);
          }
          break;
        }
        case "redirect":
          window.location.href = resp.url;
          break;
      }
    };
    initialize();
  }, [
    authorizeQueryParams.clientId,
    authorizeQueryParams.srToken,
    authorizeQueryParams.sessionId,
    history,
  ]);

  return (
    <>
      <LoadingLogo />
    </>
  );
}
